import execFor from '@utils/platform/execFor';
import { setMetrics, selectedMetricChart } from '@store/metricsChartContainer/actions';
import {
  setDimensionMetrics,
  setDimensions,
  setGlobalOrderByMetric,
} from '@store/trends/base/actions';

export const initEco = execFor.ecoServer(({ userDefinedMetrics, dispatch, dimensionList }) => {
  if (userDefinedMetrics && userDefinedMetrics.eco_server) {
    const ecoMetrics = userDefinedMetrics.eco_server;
    // trends needs a selected metric and dimension
    const defaultMetricKey = Object.keys(ecoMetrics)[0];
    const defaultMetric = ecoMetrics[defaultMetricKey];
    dispatch(setMetrics(Object.keys(ecoMetrics).slice(0, 3)));
    dispatch(selectedMetricChart(defaultMetric.name, null));
    dispatch(setDimensionMetrics([defaultMetric.name]));
    dispatch(setGlobalOrderByMetric(defaultMetric.name));

    if (dimensionList.length > 0) {
      const dimensions = dimensionList.slice(0, 3).map((d) => d.groupBy);
      dispatch(setDimensions(dimensions));
    }
  }
});
